export const figure23 = {
  chart: {
    type: 'column',
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
},
colors: ['#bfbfbf', '#00b050','#ed7d32','#ff0000'],
credits: {
    enabled: false
  },
  title: {
    text: null
  },
  subtitle: {
    text: null
  },
xAxis: {
    categories: ['Afrique', 'Amériques', 'Asie', 'Europe', 'Océanie', 'Monde']
},
yAxis: {
    min: 0,
    title: {
        text: ''
    }
},
tooltip: {
    pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
    shared: true
},
legend: {
    enabled: false,
  },
plotOptions: {
    column: {
        stacking: 'percent'
    }
},
series: [{
    name: 'Races locales dont l’état de cryoconservation n’est pas connu',
    data: [325, 435, 1227, 1135, 206, 3328]
}, {
    name: 'Races locales pour lesquelles du matériel suffisant est conservé pour permettre leur reconstitution',
    data: [18, 12, 81, 166, 0, 277]
}, {
    name: 'Races locales pour lesquelles une quantité insuffisante de matériel génétique est conservée',
    data: [29, 51, 157, 491, 0, 728]
},{
  name: 'Races locales pour lesquelles aucun matériel génétique n’est conservé',
  data: [613, 200, 779, 1768, 11, 3371]
}]
}
